import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListIndented24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconListIndented24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3 6v12a.75.75 0 0 0 1.5 0V6A.75.75 0 0 0 3 6m17.75.75a.75.75 0 0 1-.75.75H7A.75.75 0 0 1 7 6h13a.75.75 0 0 1 .75.75m-3 3.5A.75.75 0 0 1 17 11H7a.75.75 0 0 1 0-1.5h10a.75.75 0 0 1 .75.75M20 14.5a.75.75 0 0 0 0-1.5H7a.75.75 0 0 0 0 1.5zm-2.25 2.75A.75.75 0 0 1 17 18H7a.75.75 0 0 1 0-1.5h10a.75.75 0 0 1 .75.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconListIndented24);
